import { Schema } from '@blade/std-lib'

export const UserStatus = {
  Admin: 'admin',
  Member: 'member',
  Influencer: 'influencer',
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus]

export const UserStatusEmoji: Record<UserStatus, string> = {
  [UserStatus.Admin]: '👑',
  [UserStatus.Member]: '👤',
  [UserStatus.Influencer]: '⭐',
}

export const UserStatusSchema = Schema.Enum(UserStatus)
